export const currentProcessingFileBase = {
  packageID: null,
  packageName: "",
  email: "",
  is_subuser: "",
  user_document_token: "",
  status: "",
  payments: [],
  document_location: {},
  signers: {
    signer_1: {
      label: "Signer 1 - Property Owner - Grantor",
      address: "",
      phone_number: "",
      email: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      company_name: "",
    },
    signer_2: {
      label: "Signer 2 - Contractor - Grantee",
      address: "",
      phone_number: "",
      email: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      company_name: "",
    },
    signer_3: {
      label: "Signer 3",
      address: "",
      phone_number: "",
      email: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      company_name: "",
    },
  },
  processing_permit: {},
  document: {
    formID: null,
    document_name: null,
    is_notice_of_commencement: false,
    pdf_url: "",
    img_urls: [],
    cleaned_file_name: "",
    actions: {
      notarize: false,
      record: false,
      sign: false,
    },
    signer_fields: [],
    locked: false,
    tempFields: {
      formFields: [],
      selectedFormField: null,
      selectedExtraFields: [],
      currentDocument: {
        base64File: null,
        formName: "",
        fileName: "",
        files: [],
        numPages: 0,
        pageNumber: 1,
        pdfSize: 1000,
        scaleFactor: 1,
      },
      formFieldTools: {
        textField: {
          active: false,
          values: [],
          name: "text_field",
          type: "PDFTextField",
          group: "g",
          disabled: false,
        },
        checkbox: {
          active: false,
          values: [],
          name: "checkbox",
          type: "PDFCheckBox",
          group: "g",
          disabled: false,
        },
        radio: {
          active: false,
          values: [],
          name: "radio",
          type: "PDFRadioGroup",
          group: "g",
          disabled: false,
        },
        date: {
          active: false,
          values: [],
          name: "date_field",
          type: "PDFTextField",
          group: "g",
          disabled: false,
        },
        notarySeal_a: {
          active: false,
          values: [],
          name: "notary_seal_a",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        notarySignature_a: {
          active: false,
          values: [],
          name: "notary_sign_a",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        notarySeal_b: {
          active: false,
          values: [],
          name: "notary_seal_b",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        notarySignature_b: {
          active: false,
          values: [],
          name: "notary_sign_b",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        signatureA: {
          active: false,
          values: [],
          name: "sign_a",
          type: "PDFTextField",
          group: "s",
          disabled: false,
        },
        signatureB: {
          active: false,
          values: [],
          name: "sign_b",
          type: "PDFTextField",
          group: "s",
          disabled: false,
        },
        signatureC: {
          active: false,
          values: [],
          name: "sign_c",
          type: "PDFTextField",
          group: "s",
          disabled: false,
        },
      },
    },
  },
};
